import React from 'react'
// types
import { FieldArray } from 'redux-form'
// components
import renderUsers from 'components/Modals/GroupSecurityModal/Form/BusinessRule/components/UserPermissions'
// utils
import { userAndPositionProps } from 'components/FormElements/ReduxForm/ReduxEntitySelect/utils'

interface Props {
  field: string
}

const EnableGroupAccess: React.FC<Props> = ({ field }) => {
  const getUserOptions = (data) => userAndPositionProps.getOptions(data)

  return (
    <FieldArray<any>
      name={`${field}.groupsSecurityAccess`}
      component={renderUsers as any}
      getOptions={getUserOptions}
    />
  )
}

export default EnableGroupAccess
